/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".mat-form-field[_ngcontent-%COMP%]{width:100%;padding-right:20px;box-sizing:border-box}.mat-column-result[_ngcontent-%COMP%], .result-cell[_ngcontent-%COMP%]{flex:none;width:20px}.mat-column-action[_ngcontent-%COMP%]{flex-grow:0;flex-basis:120px}"];
export { styles as styles };
